import React from "react";

const BarChartHorizontalFillIcon = () => (
	<g>
		<path d='M12 3V7H3V3H12ZM16 17V21H3V17H16ZM22 10V14H3V10H22Z' />
	</g>
);

export default BarChartHorizontalFillIcon;
